import { IResponsibilityType } from 'APIPackage/CatalogsModule/interfaces/IResponsibilityType';

import { IResponsibilityTypeSelectOption } from '../interfaces/IResponsibilityTypeSelectOption';

export function createResponsibilityTypeSelectOption(
  responsibilityType: IResponsibilityType,
): IResponsibilityTypeSelectOption {
  return {
    ...responsibilityType,
    label: responsibilityType.name,
    value: responsibilityType.code,
  };
}
